import React from 'react';

// Components
import WorkspacePrivateNotes from './PrivateNotes/WorkspacePrivateNotes';

// Hooks
import { useWorkspace } from 'Shared/utils/hooks/use-workspace';

const WorkspacePrivateTab = () => {
  const { id, isGroup } = useWorkspace();

  return <WorkspacePrivateNotes workspaceId={id} isGroup={isGroup} />;
};

export default WorkspacePrivateTab;
